export const createLoadingSpinner = () => {
  const loadingSpinner = document.createElement('div');

  loadingSpinner.className = 'cloudimage-loading-spinner';

  return loadingSpinner;
};
